<template>
  <div class="zbsz-box">
	<yinliang @setVol="setVolume"/>
	<div class="zbsz-box-xian"></div>
	<div class="zbsz-box-item" @click="handleShowGly">
		<img src="../../assets/image/zbsz_guanliyuan_28@2x.png" alt=""/>
		<span>{{$t('all.guanliyuan')}}</span>
	</div>
	<div class="zbsz-box-xian"></div>
	<div class="zbsz-box-item" @click="handleShowKjdy">
		<img src="../../assets/image/zbsz_kuaijiefayan_28@2x.png" alt=""/>
		<span>{{$t('all.kuaijieduanyu')}}</span>
	</div>
	<div class="zbsz-box-xian"></div>
	<div class="zbsz-box-item" @click="handleShowGg">
		<img src="../../assets/image/zbsz_gonggao_28@2x.png" alt=""/>
		<span>{{$t('all.gonggao')}}</span>
	</div>
	<div class="zbsz-box-xian"></div>
	<div class="zbsz-box-item" @click="handleShowSvga">
		<img v-if="isSvga" src="../../assets/image/zbsz_kqtexiao_28@2x.png" alt=""/>
		<img v-if="!isSvga" src="../../assets/image/zbsz_guanbitexiao_28@2x.png" alt=""/>
		<span>{{$t('all.liwutexiao')}}</span>
	</div>
  </div>
</template>

<script>
import yinliang from "../yinliang/yinliang.vue";
import { getChatRoomDetails } from "@/api/zhibo";
export default {
  components: {
    yinliang
  },
  data() {
    return {
	  isSvga:true
    };
  },
  mounted() {
	
  },
  methods: {
	//设置音量
	setVolume(data){
		this.$emit('setVol',data)
	},
	//显示快捷短语
	handleShowKjdy(){
		this.$emit('show_kjdy')
	},
	//显示管理员
	handleShowGly(){
		this.$emit('show_gly')
	},
	//显示公告
	handleShowGg(){
		this.$emit('show_gg')
	},
	//关闭开启特效
	handleShowSvga(){
		this.isSvga = !this.isSvga
		this.$emit('show_svga',this.isSvga)
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./zhuboshezhi.css";
</style>


// WEBPACK FOOTER //
// zhuboshezhi.vue?866c77c4